import { Component, Input, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule, GoogleMap } from '@angular/google-maps';
import { UserPreferencesService } from '@app/shared/_services/user-preferences.service';

@Component({
  selector: 'app-location-map',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './location-map.component.html',
  styleUrl: './location-map.component.css'
})
export class LocationMapComponent {
  @Input() locations: any[] = [];
  zoom = 5;
  private userPref = inject(UserPreferencesService);
  @ViewChild(GoogleMap) map!: GoogleMap;

  private getLat(loc: any): number | undefined {
    return loc?.latitude ?? loc?.location?.coordinates?.[1];
  }

  private getLng(loc: any): number | undefined {
    return loc?.longitude ?? loc?.location?.coordinates?.[0];
  }

  get centerLat(): number {
    const last = this.locations[this.locations.length - 1];
    return (last && this.getLat(last)) ?? 0;
  }

  get centerLng(): number {
    const last = this.locations[this.locations.length - 1];
    return (last && this.getLng(last)) ?? 0;
  }

  lat(loc: any) { return this.getLat(loc); }
  lng(loc: any) { return this.getLng(loc); }

  onCenterChanged() {
    const center = this.map?.getCenter?.();
    const lat = typeof center?.lat === 'function' ? center.lat() : undefined;
    const lng = typeof center?.lng === 'function' ? center.lng() : undefined;
    if (typeof lat === 'number' && typeof lng === 'number') {
      this.userPref.setLastLocation({ lat, lng });
    }
  }

  onZoomChanged() {
    const zoom = this.map?.getZoom?.();
    if (typeof zoom === 'number') {
      this.userPref.setLastZoom(zoom);
    }
  }
}
